import { TFunction } from 'i18next';

export type AnomalySeverity = 'critical' | 'high' | 'moderate';

export interface AnomalySeverityInfo {
  severity: AnomalySeverity;
  label: string;
  description: string;
  colorClass: string;
  bgColorClass: string;
  dotColorClass: string;
}

export function getAnomalySeverity(
  deviationPercentage: number | null,
  t: TFunction<'insight', 'InsightsHub.Anomalies'>,
): AnomalySeverityInfo | null {
  const absDeviation = Math.abs(deviationPercentage ?? 0);

  if (absDeviation >= 50) {
    return {
      severity: 'critical',
      label: t('severity.critical'),
      description: t('severity.description_critical'),
      colorClass: 'text-red-600',
      bgColorClass: 'bg-red-600/10',
      dotColorClass: 'bg-red-600',
    };
  } else if (absDeviation >= 25) {
    return {
      severity: 'high',
      label: t('severity.high'),
      description: t('severity.description_high'),
      colorClass: 'text-orange-500',
      bgColorClass: 'bg-orange-500/10',
      dotColorClass: 'bg-orange-500',
    };
  } else {
    return {
      severity: 'moderate',
      label: t('severity.moderate'),
      description: t('severity.description_moderate'),
      colorClass: 'text-yellow-500',
      bgColorClass: 'bg-yellow-500/10',
      dotColorClass: 'bg-yellow-500',
    };
  }
}

export function getAnomalyDirection(
  deviationPercentage: number | null,
  t: TFunction<'insight', 'InsightsHub.Anomalies'>,
): string | null {
  if (deviationPercentage === null) return null;
  else if (deviationPercentage > 0) return t('direction.above_expected');
  else return t('direction.below_expected');
}
